import { Component, Injectable, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AUTH_ROUTE } from '../../common/constants/routes.constants';
import { AuthService } from '../../services/auth/auth.service';
import { environment } from '@env/environment';
import { TokenSsoRequest } from 'src/app/common/interfaces/tokenssorequest.interface';
import { ToolsService } from '@services/varios/tools.service';

@Component({
	selector: 'app-callback',
	templateUrl: './callback.component.html',
	styleUrls: ['./callback.component.scss']
})

@Injectable({
	providedIn: 'root'
})

export class CallbackComponent implements OnInit {
	
	constructor(private readonly router: Router, private readonly route: ActivatedRoute, private readonly authService: AuthService, private readonly toolsService: ToolsService) { }
	
	async  ngOnInit() {
		const params = this.route.snapshot.fragment;
		const auth = environment;

		if (!params) {
			this.router.navigate([AUTH_ROUTE]);
			return;
		}
		
		const dataCode = this.getCodeFromUrl(params);
		
		let tokenSsoRequest: TokenSsoRequest = {
			clientID: auth.authorizer.clientId,
			clientSecret: auth.authorizer.clientKey,
			redirectUri: auth.authorizer.returnUrl,
			code: dataCode,
			acrValues: 'tenant:' + auth.authorizer.tenantId,
			grantType: auth.authorizer.grantType[0],
			idSistema: auth.idSistema
		};
		
		let respuesta = await this.authService.signInWithCode(tokenSsoRequest);
		
		if(respuesta != null) {
			if(respuesta.usuario != null) {

				if (respuesta.usuario.estadoSistema == 'INACTIVO' && !this.toolsService.userInRol(['ADMINISTRADOR'])) {
					await this.toolsService.errorMensaje(respuesta.usuario.mensajeSistema);
					this.router.navigate([AUTH_ROUTE]);
				} else {
					localStorage.setItem('LOGINGSSO','1');
					this.router.navigate([this.toolsService.itemMenuDefault()]);  
				}    
			} else if(respuesta.resp == null) {
				await this.toolsService.errorMensaje("Usuario o Password inválido");
				this.router.navigate([AUTH_ROUTE]);
			} else {
				await this.toolsService.errorMensaje(respuesta.resp);
				this.router.navigate([AUTH_ROUTE]);
			}
		} else {
			await this.toolsService.errorMensaje("Usuario o Password inválido");
			this.router.navigate([AUTH_ROUTE]);
		}
	}
	
	getCodeFromUrl(query: string): string {
		let obj: string = '';
		let urlVars = query.split('&');
		for (const urlVar of urlVars) {
			if (urlVar.startsWith('code')) {
				let keyValuePair = urlVar.split('=');
				obj = keyValuePair[1];
			}
		}     
		return obj;
	} 
}